<template>
  <VuepalRemoteVideo
    v-if="videoUrl"
    v-slot="{ embedUrl }"
    :url="videoUrl"
    :autoplay="autoplay"
    :controls="controls"
    :loop="loop"
    :muted="muted"
  >
    <figure
      class="min-w-full min-h-full aspect-video top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 relative"
    >
      <iframe
        v-if="embedUrl && isPlaying"
        :src="embedUrl"
        allow="autoplay; encrypted-media; picture-in-picture"
        allowfullscreen
        class="min-w-full min-h-full aspect-video"
      />

      <button
        v-if="!isPlaying"
        class="aspect-video w-full cursor-pointer flex items-center justify-center relative"
        :aria-label="$texts('video.load')"
        @click.prevent="isPlaying = true"
      >
        <RokkaImage
          v-if="thumbnailCustom"
          :config="imageStyle"
          v-bind="thumbnailCustom"
          :hash="thumbnailCustom?.file?.rokka?.hash || ''"
          class="absolute top-0 left-0 size-full object-cover"
        />

        <img
          v-else
          :src="thumbnailOriginal?.entity?.uri?.first?.url"
          class="absolute top-0 left-0 size-full object-cover"
          :alt="videoDescription"
        />

        <SpriteSymbol name="play" class="size-[75px] z-10" />
      </button>
    </figure>
  </VuepalRemoteVideo>
</template>

<script lang="ts" setup>
import type { MediaRemoteVideoFragment } from '#graphql-operations'
import type { DefineImageStyleConfig } from '#rokka/types'

export type MediaRemoteVideoProps = {
  videoDescription?: string
  isLanding?: boolean
  isHero?: boolean
  imageStyle: DefineImageStyleConfig
  video?: MediaRemoteVideoFragment
  autoplay?: boolean
  muted?: boolean
  loop?: boolean
  controls?: boolean
}

const props = withDefaults(defineProps<MediaRemoteVideoProps>(), {
  videoDescription: '',
  isLanding: false,
  isHero: false,
  video: undefined,
  autoplay: false,
  muted: false,
  loop: false,
  controls: true,
})

const isPlaying = ref(props.isLanding || false)

// add autoplay and muted when displayed on landing page
const videoUrl = computed(() => {
  if (!props.video?.url) return undefined
  return props.video.url
})
const thumbnailCustom = computed(() => props.video?.thumbnailCustom)
const thumbnailOriginal = computed(() => props.video?.thumbnailOriginal)
</script>
